/**
 * Client Error Reporter
 * Reports frontend errors to the server for production observability
 */

const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api'

let reportCount = 0
const MAX_REPORTS_PER_SESSION = 50

function reportError({ message, stack, componentStack }) {
  if (import.meta.env.DEV) return
  if (reportCount >= MAX_REPORTS_PER_SESSION) return
  reportCount++

  const payload = {
    message: String(message).substring(0, 1000),
    stack: stack ? String(stack).substring(0, 2000) : undefined,
    componentStack: componentStack ? String(componentStack).substring(0, 2000) : undefined,
    url: window.location.href,
    userAgent: navigator.userAgent
  }

  // Use sendBeacon for reliability (works even during page unload)
  const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' })
  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${API_BASE}/client-errors`, blob)
  } else {
    fetch(`${API_BASE}/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(() => {})
  }
}

/**
 * Install global error handlers (call once in main.jsx)
 */
export function installGlobalErrorHandlers() {
  if (import.meta.env.DEV) return

  window.addEventListener('error', (event) => {
    reportError({
      message: event.message || 'Uncaught error',
      stack: event.error?.stack
    })
  })

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    reportError({
      message: reason?.message || String(reason) || 'Unhandled promise rejection',
      stack: reason?.stack
    })
  })
}

export default reportError
